// extracted by extract-css-chunks-webpack-plugin
module.exports = {"heading":"css-2VTF9Kpg4p","heading_inner":"css-7gokYh9j6e","heading_inner__light":"css-2xQJqOLXFb","heading__full":"css-3ZuosvtDeX"};